<template>
  <div :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}">
    <feather-icon icon="Edit3Icon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="editRecord" />
    <feather-icon icon="Trash2Icon" svgClasses="h-5 w-5 hover:text-danger cursor-pointer"
      @click="confirmDeleteRecord" />
  </div>
</template>

<script>
export default {
  name: 'CellRendererActions',
  methods: {
    editRecord() {
      // 1. Set pop up title
      this.$store.dispatch(
        'setShopPopUpTitle',
        `Επεξεργασία ${this.params.data.name}`
      )
      // 2. Set object to edit
      this.$store.dispatch('setShop', this.params.data)
      // 3. Display pop up
      this.$store.dispatch('toggleShopsPopUp', true)
      // this.item = this.params.data;
      // this.$parent.$parent.editRecord(this.item);
      // this.$router.push("settings/sources/edit/" + this.params.data.id).catch(() => {})
    },
    confirmDeleteRecord() {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Επιβεβαίωση διαγραφής',
        text: `Πρόκειται να διαγράψετε την εγγραφή "${this.params.data.name}"`,
        accept: this.deleteRecord,
        acceptText: 'Διαγραφή',
      })
    },
    deleteRecord() {
      this.$store
        .dispatch('deleteShop', this.params.data.id)
        .then(() => {
          this.showDeleteSuccess()
        })
        .catch((err) => {
          console.error(err)
        })
    },
    showDeleteSuccess() {
      this.$vs.notify({
        color: 'success',
        title: ' Διαγραφή καταστήματος',
        position: 'top-right',
        text: 'Η διαγραφή του καταστήματος έγινε με επιτυχία',
      })
    },
  },
}
</script>
